import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import SignupSuccessController from './signup-success.controller';
import SuccessAuth from '../common/successAuth/SuccessAuth';

/**
 * @extends ClockoutController
 * @extends SignupSuccessController
 * @extends Component
 */
class SignupSuccess extends Inherit(SignupSuccessController, Component) {
    render() {
        return (
            <SuccessAuth
                title="Welcome to"
                titlePartTwo="Clockout!"
                description="Your account setup is complete, proceed to your EWA dashboard"
                continueButtonText="Go to Sign In"
                continueButtonOnClick={() => this.navigateLogin()}
            />
        );
    }

}

export default withHooks(SignupSuccess);

